module.exports = __webpack_public_path__ + "img/yinLian.8d6b92d5.png";